import * as React from 'react';
import cn from 'clsx';
import styles from './styles.css';
import { useDeviceType, ArticleParagraph1, InformationTooltip } from '@cian/ui-kit';
import { IconFunctionalInformationCircle16 } from '@cian/ui-kit-design-tokens/icons';
import { IRow } from '../../repositories/mortgage-broker-calculator/entities/mortgage_listing/Row';
import { PskTooltipContent } from './constants';

interface ICreditInfoModalContentProps {
  creditInfo?: IRow[] | null;
}

export const CreditInfoModalContent: React.FC<ICreditInfoModalContentProps> = props => {
  const { creditInfo } = props;
  const deviceType = useDeviceType();

  if (!creditInfo) {
    return null;
  }

  return (
    <ul className={cn(styles['wrapper'], styles[deviceType])}>
      {creditInfo.map((el, index) => {
        return (
          <li key={index} className={cn(styles['item-wrapper'], styles[deviceType])}>
            <ArticleParagraph1 color="gray60_100">
              {el.key}
              {el.tooltip && (
                <InformationTooltip content={<PskTooltipContent />} header={el.tooltip}>
                  <span className={styles['tooltip-icon']}>
                    <IconFunctionalInformationCircle16 />
                  </span>
                </InformationTooltip>
              )}
            </ArticleParagraph1>
            <ArticleParagraph1>{el.value}</ArticleParagraph1>
          </li>
        );
      })}
    </ul>
  );
};
